import {
    getQCJobThumbnails,
    Thumbnail,
    ThumbnailParams,
} from '@pluto/rest';
import {
    Action,
    ActionFunction1,
    ActionFunction2,
    createAction,
} from 'redux-actions';
import tryToCatch from 'try-to-catch';
import {ThumbnailMarker} from '../../../Timeline/TimelineTypes';

export const THUMBNAILS_SET = 'THUMBNAILS_SET';
export const THUMBNAILS_RESET = 'THUMBNAILS_RESET';

export type ThumbnailsPayload = ThumbnailMarker[] | null;

export const toThumbnailMarker = (thumbnail: Thumbnail): ThumbnailMarker => {
    const {
        id,
        start,
        src,
        srcDrawRect,
    } = thumbnail;
    
    return {
        identifier: String(id),
        start,
        src,
        srcDrawRect,
    };
};

export const parseThumbnails = (thumbnails: Thumbnail[]): ThumbnailMarker[] => {
    if (!thumbnails)
        return [];
    
    return thumbnails.map(toThumbnailMarker);
};

export const setThumbnails = createAction<Promise<ThumbnailsPayload>, string, ThumbnailParams>(THUMBNAILS_SET, async (url: string, params: ThumbnailParams): Promise<ThumbnailsPayload> => {
    const [error, thumbnails] = await tryToCatch(getQCJobThumbnails, url, params);
    
    if (!error) {
        return parseThumbnails(thumbnails);
    }
    
    console.error('Failed to fetch Thumbnails', error);
    
    return null;
});

export const resetThumbnails = createAction<void>(THUMBNAILS_RESET);

export type SetThumbnails = ActionFunction2<string, ThumbnailParams, Action<Promise<ThumbnailsPayload>>>;
export type ResetThumbnails = ActionFunction1<void, Action<void>>;
